<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item :label="label">
        <Input style="width:200px" placeholder="请输入名称关键字" v-model="searchCondition.name" clearable />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        :data-url="url"
        method="get"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        keyField="id"
        :selectedItems="selectedItems"
        keepSelected
      ></Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseSelect",
  data() {
    return {
      label:'章节名称',
      columns: [
        {
          title: "章节名称",
          key: "name"
        },
        {
          title: "所属分类",
          key: "classify_name"
        }
      ],
      selectList: [],
      searchCondition: {
        name: "",
      },
      url: '/api/exam/exercise',
    };
  },
  props: {
    selectedItems: {
      type: Array
    },
    selectType: {
      type: String,
      default: "multi"
    },
    type: {
      type: Number,
      default: 7
    }
  },
  created () {
    if(this.type == 8){
      this.url = '/api/exam/packageSimulation';
      this.columns[0].title = '考试名称';
      this.label = '考试名称'
    }
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(item => {
        item.classify_name = item.classify.title;
      });
      // rows.forEach(i => {});
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.name = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = [...val];
    },
    getSelectList() {
      return this.selectList;
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems);
    },
  }
};
</script>
<style lang="scss" scoped>
</style>